// extracted by mini-css-extract-plugin
export default {"tooltip":"VS-z","arrow":"WS-z"};